import { ActionStatus } from '../../../Constants';
import { haveIAlreadyGone } from '../../Game/GamePlayerInfo';
import { available_docks_for_guest, CARD_NAMES, get_points_for_card } from '../../TwoD/Common/CardUtilities';

export default function artificialReceiveSpecial(gamePlayerController, aiPackage) {
    const gamePlayerData = gamePlayerController.gamePlayerData;
    // const tradelane = gamePlayerData.special_card_orbit;
    const cardId = gamePlayerData.special_card;

    const docks = available_docks_for_guest(gamePlayerData.docks, cardId);


    const iHaveNotGoneYet = !haveIAlreadyGone(
        gamePlayerController.gameData, gamePlayerData);
    let question = `Have I gone yet?`;
    let answer = !iHaveNotGoneYet;
    let reason = `If I have not gone, I can get Lodging still.`;
    aiPackage.addProvenance(question, answer, reason);

    let dockPoints = [];
    docks.forEach(dockIndex => {
        let pointData = get_points_for_card(
            gamePlayerData.station,
            gamePlayerData.robot_assignments,
            gamePlayerData.lodging,
            cardId, dockIndex,
            true,
            iHaveNotGoneYet);  // which means I can still use the card.
        let points = -1;
        if (pointData.points !== 'Danger') points = pointData.points;
        dockPoints.push(points);
    })
    const max = Math.min(...dockPoints);
    const dock = docks[dockPoints.indexOf(max)];
    const name = CARD_NAMES[cardId];

    question = `Which Dock is best for ${name}? `;
    answer = dock;
    reason = `Best chance to possibly make ${max} points.`;
    aiPackage.addProvenance(question, answer, reason);

    const attacker = gamePlayerController.gameData.gameplayer_set.find(gamePlayer => gamePlayer.action_status===ActionStatus.ATTACKING_ID);

    aiPackage.success = true;
    aiPackage.addToMessage(`Place ${name} from ${attacker.name} in Dock ${dock}`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.placeSpecialGuest(dock);
    }
}
